import React from 'react';
import { PropTypes } from 'prop-types';
import Modal from 'components/ui/Modal';
import AlertBox from 'components/ui/AlertBox';
import { FormattedMessage } from 'react-intl';

function BookingEmailSent({ isOpen, onClose, customerEmail }) {
  const subtitle = customerEmail ? (
    <>
      <FormattedMessage id="afterSales.emailSentSubtitle" />
      {'\n'}
      <FormattedMessage id="afterSales.emailSentRecipient" values={{ email: customerEmail }} />
    </>
  ) : (
    <FormattedMessage id="afterSales.emailSentSubtitle" />
  );

  return (
    <Modal
      alert={
        <AlertBox variant={AlertBox.variants.SUCCESS}>
          <FormattedMessage id="afterSales.emailSentSuccess" />
        </AlertBox>
      }
      title={<FormattedMessage id="afterSales.emailSent" />}
      subtitle={subtitle}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}

BookingEmailSent.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  customerEmail: PropTypes.string
};

export default BookingEmailSent;
